import { ApplicationState, NEiTThunk, NEiTAsyncThunk } from '..';
import { UserAdminActions } from './actionTypes';
import * as adminApi from './api';
import notification from '../notification';
import { AnagraficaCustom, UbicazioneCustom } from './models';

type Actions = 
    UserAdminActions

export const loadAnagraficheCustom = (): NEiTThunk<void, Actions> => (dispatch, getState) => {
    dispatch({ type: 'core/BEGIN_AJAX_CALL' });    
    const state: ApplicationState = getState();

    adminApi.getAnagraficheCustom(state, false)
        .then(result => {
            const anagrafiche = result.map(a => new AnagraficaCustom(a));

            dispatch({ type: 'userAdmin/LOAD_ANAGRAFICHE_CUSTOM', value: anagrafiche });
            dispatch({ type: 'core/END_AJAX_CALL' });
        })
        .catch(error => {
            dispatch({ type: 'core/END_AJAX_CALL' });
            notification.error(error.message);
        });
}

export const saveAnagraficheCustom = (
    anagraficheCustom: ReadonlyArray<AnagraficaCustom>
): NEiTThunk<void, Actions> => (dispatch, getState) => {
    dispatch({ type: 'core/BEGIN_AJAX_CALL' });    
    const state: ApplicationState = getState();

    const anagrafiche = anagraficheCustom
        .filter(a => a.isModificata())
        .map(a => ({ 
            idAnagrafica: a.idAnagrafica, 
            ragioneSocialeCustom: a.ragioneSocialeCustom
        }));
    
    const destinatari = anagraficheCustom
        .map(a => a.destinatari)
        .reduce((prev, current) => prev.concat(current))
        .filter(d => d.isModificato())
        .map(d => ({
            idDestinatario: d.idDestinatario,
            idAnagrafica: d.idAnagrafica,
            destinatarioCustom: d.destinatarioCustom
        }));

    if (anagrafiche.length === 0 && destinatari.length === 0) {
        return;
    }

    adminApi.saveAnagraficheCustom(state, anagrafiche, destinatari)
        .then(() => {
            dispatch({ type: 'core/END_AJAX_CALL' });
            
            anagraficheCustom.forEach(a => a.conferma());

            notification.success('Sedi salvate con successo.', 'Salvataggio completato');
        })
        .catch(error => {
            dispatch({ type: 'core/END_AJAX_CALL' });
            notification.error(error.message);
        });
}

//////////////////////////////////////////////////////////////

export const loadUbicazioni = (): NEiTAsyncThunk<void, Actions> => async (dispatch, getState) => {
    try {
        dispatch({ type: 'core/BEGIN_AJAX_CALL' });
        const state: ApplicationState = getState();

        const result = await adminApi.getUbicazioni(state, false);        
        const ubicazioni = result
            .map(u => new UbicazioneCustom(u))            
            .sort((p, n) => p.matricola > n.matricola ? 1 : -1);

        dispatch({ type: 'userAdmin/LOAD_UBICAZIONI', value: ubicazioni });
    } catch (error) {
        if (error instanceof Error) {
            notification.error(error.message);
        }
    } finally {
        dispatch({ type: 'core/END_AJAX_CALL' });
    }
}

export const saveUbicazioni = (
    ubicazioniCustom: ReadonlyArray<UbicazioneCustom>
): NEiTAsyncThunk<void, Actions> => async (dispatch, getState) => {
    try {
        dispatch({ type: 'core/BEGIN_AJAX_CALL' });    
        const state: ApplicationState = getState();

        const ubicazioni = ubicazioniCustom
            .filter(a => a.isModificata())
            .map(a => ({ 
                idSpecifica: a.idSpecifica, 
                edificioNuovo: a.edificioNuovo,
                ufficioNuovo: a.ufficioNuovo,
                pianoNuovo: a.pianoNuovo,
                referenteNuovo: a.referenteNuovo
            }));

        if (ubicazioni.length === 0) {
            return;
        }
    
        await adminApi.saveUbicazioniCustom(state, ubicazioni);
        dispatch({ type: 'core/SAVE_UBICAZIONI' });

        ubicazioniCustom.forEach(u => u.conferma());
        
        notification.success('Ubicazioni salvate con successo.', 'Salvataggio completato');
    } catch (error) {
        if (error instanceof Error) {
            notification.error(error.message);
        }
    } finally {
        dispatch({ type: 'core/END_AJAX_CALL' });
    }
}